document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".vertical_accordion-item");

    function handleAccordionClick(item) {
        const isActive = item.classList.contains("active");
        const activeItems = document.querySelectorAll(".vertical_accordion-item.active");

        // If there's only one active item and it's being clicked, prevent closing it
        if (activeItems.length === 1 && isActive) {
            return; // Prevent closing the last open item
        }

        // Close all items
        accordionItems.forEach(i => {
            i.classList.remove("active");
            i.setAttribute("aria-expanded", "false");
            i.querySelector('.content').setAttribute('aria-hidden', 'true');
        });

        // If the clicked item wasn't already active, activate it
        if (!isActive) {
            item.classList.add("active");
            item.setAttribute("aria-expanded", "true");
            item.querySelector('.content').setAttribute('aria-hidden', 'false');
            item.focus(); // Ensure focus is applied to the active item
        }
    }

    // Initialize each accordion item
    accordionItems.forEach(item => {
        item.setAttribute("tabindex", "0"); // Make focusable
        item.setAttribute("role", "tab");
        item.setAttribute("aria-expanded", "false");

        const content = item.querySelector('.content');
        content.setAttribute("role", "tabpanel");
        content.setAttribute("aria-hidden", "true");

        item.addEventListener("click", () => handleAccordionClick(item));

        // Keyboard accessibility
        item.addEventListener("keydown", (event) => {
            switch (event.key) {
                case "Enter":
                case " ":
                    event.preventDefault();
                    handleAccordionClick(item);
                    break;
                case "ArrowDown":
                    focusNextItem(item);
                    break;
                case "ArrowUp":
                    focusPreviousItem(item);
                    break;
            }
        });
    });

    // Handle focus for next and previous items
    function focusNextItem(currentItem) {
        const nextItem = currentItem.nextElementSibling || accordionItems[0];
        nextItem.focus();
    }

    function focusPreviousItem(currentItem) {
        const prevItem = currentItem.previousElementSibling || accordionItems[accordionItems.length - 1];
        prevItem.focus();
    }

    // Ensure at least one item is active on load
    function ensureOneActive() {
        const activeItem = document.querySelector(".vertical_accordion-item.active");
        if (!activeItem && accordionItems.length > 0) {
            accordionItems[0].classList.add("active");
            accordionItems[0].setAttribute("aria-expanded", "true");
            accordionItems[0].querySelector('.content').setAttribute('aria-hidden', "false");
        }
    }

    // Run on page load
    ensureOneActive();

    // Collapse accordions on window resize (if below 960px), ensuring at least one remains open
    window.addEventListener("resize", () => {
        if (window.innerWidth < 960) {
            let activeItem = document.querySelector(".vertical_accordion-item.active");
            
            // If no active item, activate the first one
            if (!activeItem && accordionItems.length > 0) {
                accordionItems[0].classList.add("active");
                accordionItems[0].setAttribute("aria-expanded", "true");
                accordionItems[0].querySelector('.content').setAttribute('aria-hidden', "false");
            }
        }
    });
});


// Function to toggle classes based on the clicked index
function toggleDirectionClass() {
    document.querySelectorAll(".accordions_vertical_scroll_wrapper").forEach(wrapper => {
        const titles = wrapper.querySelectorAll(".vertical_accordion-item .title");

        titles.forEach((title, index) => {
            title.addEventListener("click", function () {
                let isActive = title.classList.contains("ps-s-accordiontitle-left");

                // Toggle classes based on the clicked index
                titles.forEach((t, i) => {
                    if (i <= index && !isActive) {
                        t.classList.add("ps-s-accordiontitle-left");
                    } else if (i >= index) {
                        t.classList.remove("ps-s-accordiontitle-left");
                    }
                });
            });
        });
    });
}

toggleDirectionClass();
